import { render, staticRenderFns } from "./PublicProjectApartmentBuildings.vue?vue&type=template&id=154a94a4&"
import script from "./PublicProjectApartmentBuildings.vue?vue&type=script&lang=js&"
export * from "./PublicProjectApartmentBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports